import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, forkJoin } from 'rxjs';
import { PROFILE_SELECTOR_IDP_APPS } from '../../../constants/profile-selector/profile-selector-constants';
import { ProfileSelectorEndpointsKeys } from '../../../constants/profile-selector/profile-selector.enums';
import { HttpRequestMethods, IDP_APPS } from '../../../constants/utils';
import { EndpointKeysCommon } from '../../../constants/utils/app.constants';
import { OauthAEMConfig } from '../../../models/login';
import { ProfileSelectorAEM } from '../../../models/profile-selector/profile-selector-aem.interface';
import { HttpHeadersPayload, ReplaceItem } from '../../../models/utils';
import { ApplicationConfig } from '../../../utils/config';
import { UserDataService } from '../../login/data-services/user-session/user-data/user-data.service';
import { ApiBuilder, AppConfigService, handleError } from '../../utils';

@Injectable({
  providedIn: 'root'
})
export class ProfileSelectorService {
  http = inject(HttpClient);
  appConfig = inject(AppConfigService);
  applicationConfig = inject(ApplicationConfig);
  userData = inject(UserDataService);

  private headerInfo: HttpHeadersPayload = {
    'Content-Type': 'application/json'
  };

  _errorHandler = handleError.bind(this);

  getAEMContentServiceCall = (): Observable<ProfileSelectorAEM> => {
    return new ApiBuilder<undefined, ProfileSelectorAEM>(
      this.http,
      this.appConfig
    )
      .app(PROFILE_SELECTOR_IDP_APPS)
      .endpointKey(ProfileSelectorEndpointsKeys['PROFILE_SELECTOR_AEM_URL'])
      .method(HttpRequestMethods['GET'])
      .errorHandler(this._errorHandler)
      .library('PROFILE_SELECTOR_AEM')
      .create();
  };

  getStaticContentForProfileSelectorScreen(): Observable<
    [ProfileSelectorAEM, OauthAEMConfig]
  > {
    return forkJoin([
      this.getAEMContentServiceCall(),
      this.userData.getAuthConfigContent()
    ]);
  }

  postAccountTypeCall = (acctType: string): Observable<string> => {
    return new ApiBuilder<{ cacheKey: string; value: string }, string>(
      this.http,
      this.appConfig
    )
      .app(PROFILE_SELECTOR_IDP_APPS)
      .endpointKey(ProfileSelectorEndpointsKeys['SESS_CUSTOMER_EDP_DATA_URL'])
      .method(HttpRequestMethods['POST'])
      .payload({
        cacheKey: 'edpCorpData',
        value: acctType
      })
      .httpHeaders(this.headerInfo)
      .errorHandler(this._errorHandler)
      .library('SESS_CUSTOMER_EDP_DATA')
      .create();
  };

  getAccountType = (
    cacheKey: string
  ): Observable<{
    cacheKey: string;
    value: string;
  }> => {
    const endpointUrl = this.applicationConfig.get(
      'APP_SESS_CUSTOMER_EDP_RETRIEVE_URL'
    );

    const finalUrl: ReplaceItem[] = [
      {
        src: '/content/dam/delta-applications/login/auth-config.json',
        target: `${endpointUrl}?CacheKey=${cacheKey}`
      }
    ];

    return new ApiBuilder<
      undefined,
      {
        cacheKey: string;
        value: string;
      }
    >(this.http, this.appConfig)
      .app(IDP_APPS.COMMON)
      .endpointKey(EndpointKeysCommon.APP_AUTH_CONFIG_JSON)
      .overrideEndpoint(finalUrl)
      .method(HttpRequestMethods['GET'])
      .httpHeaders(this.headerInfo)
      .errorHandler(this._errorHandler)
      .library('SITE_WIDE_SHARED_CORE')
      .create();
  };
}
